<div class="d-flex" id="wrapper">

  <admin-sidebar id="admin-sidebar"></admin-sidebar>

  <div id="page-content-wrapper">

    <admin-navigation></admin-navigation>

    <div class="container-fluid">
      <div class="mt-4 mt-md-4 mb-2 mb-md-2">
        <div class="col-md-6 redirect-link px-0 px-md-0">
          <i class="fa fa-angle-left align-middle"></i>
          <a [routerLink]="['/admin/organisations']" class="pl-2 pl-md-2 align-middle">All Enterprises</a>
        </div>
      </div>
      <div class="mt-5 mt-md-5 mb-3 mb-md-3">
        <div class="d-inline-flex">
          <h1 class="font-weight-bold page-title">{{ name }}</h1>&nbsp;
          <i class="fa fa-edit align-middle pointer" (click)="openUpdateNameModal()"></i>
          <span id="openUpdateNameModal" data-toggle="modal" data-target="#updateName"></span>
        </div>
        <button type="button" class="btn btn-danger pull-right" *ngIf="status == 'Active'" data-toggle="modal" data-target="#updateStatus">Suspend Enterprise</button>
        <button type="button" class="btn btn-warning pull-right" *ngIf="status != 'Active'" data-toggle="modal" data-target="#updateStatus">Activate Enterprise</button>
      </div>

      <div class="alert alert-success alert-dismissible fade show mt-2" role="success" *ngIf="success">
        <button type="button" class="close" data-dismiss="alert">&times;</button>
        {{ successMessage }}
      </div>

      <div class="mb-1 mb-md-1">
        <div class="d-inline-flex"><p class="font-weight-bold page-title mb-1 mb-md-1 mr-1 mr-md-1">Staffs:</p> {{ users_total }}</div><br>
        <div class="d-inline-flex"><p class="font-weight-bold page-title mb-1 mb-md-1 mr-1 mr-md-1">Created On:</p> {{ created * 1000 | date:'dd LLL yyyy':'+1200'}} </div><br>
        <div class="d-inline-flex"><p class="font-weight-bold page-title mb-1 mb-md-1 mr-1 mr-md-1">Type:</p> {{ orgType | titlecase }}
          <i class="ml-1 ml-md-1 fa fa-edit align-middle pointer" (click)="openUpdateTypeModal()"></i>
          <span id="openUpdateTypeModal" data-toggle="modal" data-target="#updateType"></span>
        </div><br>
        <div class="d-inline-flex"><p class="font-weight-bold page-title mb-1 mb-md-1 mr-1 mr-md-1">Domains: </p> {{ domains }}
          <i class="ml-1 ml-md-1 fa fa-edit align-middle pointer" (click)="openUpdateDomainsModal()"></i>
          <span id="openUpdateDomainsModal" data-toggle="modal" data-target="#updateDomain"></span>
        </div><br>
        <div class="d-inline-flex"><p class="font-weight-bold page-title mb-1 mb-md-1 mr-1 mr-md-1">Free Trials: </p> {{ freeTrialDisplay }}
          <i class="ml-1 ml-md-1 fa fa-edit align-middle pointer" (click)="openUpdateFreeTrialsModal()"></i>
          <span id="openUpdateFreeTrialsModal" data-toggle="modal" data-target="#updateFreeTrial"></span>
        </div><br>
        <div class="d-inline-flex"><p class="font-weight-bold page-title mb-1 mb-md-1 mr-1 mr-md-1">Voucher: </p> {{ voucherString }}
          <i class="ml-1 ml-md-1 fa fa-edit align-middle pointer" (click)="openUpdateVouchersModal()"></i>
          <span id="openUpdateVouchersModal" data-toggle="modal" data-target="#updateVouchersModal"></span>
        </div><br>
        <div class="d-inline-flex"><p class="font-weight-bold page-title mb-1 mb-md-1 mr-1 mr-md-1">Company size: </p> {{ total_users }}
          <i class="ml-1 ml-md-1 fa fa-edit align-middle pointer" (click)="openTotalUsersModal()"></i>
          <span id="openTotalUsersModal" data-toggle="modal" data-target="#updateTotalUsersModal"></span>
        </div>
      </div>

      <div class="text-right pt-1 pt-md-1">
        <div class="btn-group btn-group-toggle" data-toggle="buttons">
          <label class="btn btn-secondary">
            <input type="radio" name="options" id="option1" autocomplete="off" (click)="lastWeek()">
            <i class="fa fa-angle-left"></i>
          </label>
          <label class="btn disable-white">
            <input type="radio" name="options" id="option2" autocomplete="off" checked> {{ today }}
          </label>
          <label class="btn btn-secondary">
            <input type="radio" name="options" id="option3" autocomplete="off" (click)="nextWeek()">
            <i class="fa fa-angle-right"></i>
          </label>
        </div>
      </div><br/>

      <div class="row mt-2 mt-md-2 mb-2 mb-md-5">
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Weekly Logins</h4>
              <p class="card-text">
                <canvas id="canvas-logins">{{ chartLogins }}</canvas>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Videos Played</h4>
              <p class="card-text">
                <canvas id="canvas-videos"></canvas>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Points Earned</h4>
              <p class="card-text">
                <canvas id="canvas-points"></canvas>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-4 mb-md-4">
        <div class="col-md-4">
          <input type="text" class="form-control" placeholder="Search name, email" id="searchUserInput">
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <table class="table table-borderless">
            <colgroup>
              <col width="20%">
              <col width="20%">
              <col width="10%">
              <col width="10%">
              <col width="10%">
              <col width="10%">
              <col width="20%">
            </colgroup>
            <thead>
            <tr>
              <th class="text-left">Name</th>
              <th class="text-left">Email</th>
              <th class="text-center">Points Earned</th>
              <th class="text-center">Videos Watch</th>
              <th class="text-center">Weekly Login</th>
              <th class="text-center">Last Login</th>
              <th class="text-right">Manage Permission</th>
            </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of users">
                <td class="text-left align-middle">
                  <img class="rounded-circle user-avatar" [src]="user.avatar" *ngIf="user.avatar !== ''; else noAvatar">
                  <ng-template #noAvatar>
                    <img class="rounded-circle user-avatar" src="../../../../../assets/images/avatars/default_profile.png">
                  </ng-template>
                  <span class="pl-md-3">{{ user.first_name }} {{ user.last_name }}</span>
                </td>
                <td class="text-left align-middle">{{ user.email }}</td>
                <td class="text-center align-middle">{{ user.points }}</td>
                <td class="text-center align-middle">{{ user.videos }}</td>
                <td class="text-center align-middle">{{ user.weekly_login }}</td>
                <td class="text-left align-middle">
                  <span *ngIf="user.last_login != 0">
                    {{ user.last_login * 1000 | date:'h:mma dd LLL yyyy':'+1200'}}
                  </span>
                  <span *ngIf="user.last_login == 0">
                    -
                  </span>
                </td>
                <td class="text-center align-middle">
                  <label class="switch">
                    <input type="checkbox" [checked]="user.role == 'manager'" value="{{ user.id }}" (change)="roleUpdate($event)">
                    <span class="slider round"></span>
                  </label>
                </td>
              </tr>
              <tr *ngIf="users?.length == 0 && processingSearch == 0">
                <td class="align-middle text-center" colspan="7">No Record Found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

    <!-- Pagination -->
    <nav *ngIf="users?.length > 0">
      <ul class="pagination justify-content-center">
        <li
          class="page-item"
          [ngClass]="{'disabled': currentPage == 1}"
          (click)="paginate(currentPage - 1)"
        >
          <a class="page-link" tabindex="-1">Previous</a>
        </li>
        <li
          class="page-item"
          *ngFor="let link of pageLinks"
          [ngClass]="{'active': currentPage == link}"
          (click)="paginate(link)"
        >
          <a class="page-link">{{ link }} <span class="sr-only" *ngIf="currentPage == link">(current)</span></a>
        </li>
        <li
          class="page-item"
          [ngClass]="{'disabled': currentPage == lastPage}"
          (click)="paginate(currentPage + 1)"
        >
          <a class="page-link">Next</a>
        </li>
      </ul>
    </nav>
    <!-- End of Pagination -->

    <!-- Edit Name Modal -->
    <div class="modal fade" id="updateName" tabindex="-1" role="dialog" aria-labelledby="updateNameLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="editOrganisationLabel">Update Enterprise Name</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
            <form [formGroup]="updateNameForm" (ngSubmit)="updateName()">
            <div class="modal-body">
              <div class="md-input">
                <input class="md-form-control"
                       type="text"
                       required
                       formControlName="name"
                       value="{{name}}"
                       [ngClass]="{'error': (submitted && updateNameForm.invalid && fname.name.invalid) || (fname.name.dirty && fname.name.invalid)}">
                      <div *ngIf="submitted && fname.name.errors" class="text-danger">
                        <div>{{ nameError }}</div>
                      </div>
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Enterprise Name</label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">Cancel</button>
              <button type="submit" class="btn btn-primary btn-modal-save">
                <img src="../../../../assets/images/loader.gif" *ngIf="loading">Save</button>
            </div>
            </form>
        </div>
      </div>
    </div>
    <!-- End Name Modal -->

    <!-- Edit Type Modal -->
    <div class="modal fade" id="updateType" tabindex="-1" role="dialog" aria-labelledby="updateTypeLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="editOrganisationLabel">Update Enterprise Type</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
            <form [formGroup]="updateTypeForm" (ngSubmit)="updateType()">
            <div class="modal-body">
              <div class="md-input">
                <select
                  class="md-form-control enterprise-type"
                  required
                  formControlName="type"
                >
                  <option value="company" selected>Company</option>
                  <option value="school">School</option>
                </select>
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Enterprise Type</label>
                <span class="select-down-icon"><i class="fa fa-caret-down"></i></span>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">Cancel</button>
              <button type="submit" class="btn btn-primary btn-modal-save">
                <img src="../../../../assets/images/loader.gif" *ngIf="loading">Save</button>
            </div>
            </form>
        </div>
      </div>
    </div>
    <!-- End Type Modal -->

    <!-- Edit Domain Modal -->
    <div class="modal fade" id="updateDomain" tabindex="-1" role="dialog" aria-labelledby="updateNameLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" >Update Enterprise Domain</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
            <div class="modal-body">
              <div>
                <div *ngFor="let domain of domainRows; let i = index" class="md-input domain-row" style="margin:10px 0px;">
                  <div>
                    <input class="md-form-control"
                           required
                           type="text"
                           [id]="'domainInput_' + i "
                           (keyup)="onKeyUpDomain(i)"
                           [(ngModel)]="domain.text"
                           [ngClass]="{'error': (submitted && this.domainReqErr && i == 0)}">
                    <a *ngIf="i != 0" class="select-down-icon cursor-pointer" (click)="deleteDomainRow(i)"><i class="fa fa-trash"></i></a>
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label *ngIf="i == 0" >Domain</label>
                  </div>
                  <div [id]="'domainError_' + i " class="text-danger domain-errors position-static d-none"></div>
                </div>
                <div class="" style="margin:10px 0px 0px 0px;">
                  <button type="button" class="badge module-button-white not-active mt-2" (click)="addDomainRow()">+ Add Domain</button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-modal-save" (click)="updateDomain()">
                <img src="../../../../assets/images/loader.gif" *ngIf="loading">Save</button>
            </div>
        </div>
      </div>
    </div>
    <!-- End Domain Modal -->

    <!-- Update Status Modal -->
    <div class="modal fade" id="updateStatus" tabindex="-1" role="dialog" aria-labelledby="updateNameLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" *ngIf="status == 'Active'">Suspend Enterprise</h5>
            <h5 class="modal-title font-weight-bold" *ngIf="status != 'Active'">Activate Enterprise</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
            <div class="modal-body text-danger" *ngIf="status == 'Active'">Are you sure to suspend this enterprise?</div>
            <div class="modal-body" *ngIf="status != 'Active'">Are you sure to activate this enterprise?</div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-danger btn-modal-save btn-suspend" (click)="updateStatus('Suspended')" *ngIf="status == 'Active'">Suspend</button>
              <button type="button" class="btn btn-danger btn-modal-save" (click)="updateStatus('Active')" *ngIf="status != 'Active'">Activate</button>
            </div>
        </div>
      </div>
    </div>
    <!-- Update Status Modal -->

    <!-- Update Free Trial Modal -->
    <div class="modal fade" id="updateFreeTrial" tabindex="-1" role="dialog" aria-labelledby="updateNameLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" >Update Enterprise Free Trial Users</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <div *ngFor="let freeTrial of freeTrialRows; let i = index" class="md-input domain-row" style="margin:10px 0px;">
                <div>
                  <input class="md-form-control"
                         required
                         type="text"
                         [id]="'freeTrialInput_' + i "
                         (keyup)="onKeyUpFreeTrial(i)"
                         [(ngModel)]="freeTrial.text"
                         [ngClass]="{'error': (submitted && this.domainReqErr && i == 0)}">
                  <a class="select-down-icon cursor-pointer" (click)="deleteFreeTrialRow(i)"><i class="fa fa-trash"></i></a>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label *ngIf="i == 0" >Free Trials</label>
                </div>
                <div [id]="'freeTrialError_' + i " class="text-danger domain-errors position-static d-none"></div>
              </div>
              <div class="" style="margin:10px 0px 0px 0px;">
                <button type="button" class="badge module-button-white not-active mt-2" (click)="addFreeTrialRow()">+ Add Free Trials</button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary btn-modal-save" (click)="updateFreeTrial()">
              <img src="../../../../assets/images/loader.gif" *ngIf="loading">Save</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Update Free Trial Modal -->

    <!-- Update Voucher Modal -->
    <div class="modal fade" id="updateVouchersModal" tabindex="-1" role="dialog" aria-labelledby="updateNameLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" >Update Enterprise Voucher</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-danger mb-3" *ngIf="voucherDuplicate">Voucher code already used</div>
            <div class="text-danger mb-3" *ngIf="voucherDuplicateEntry">Duplicate voucher code</div>
            <div class="text-success mb-3" *ngIf="voucherSuccessfullyDeleted">Voucher successfully deleted</div>
            <div>
              <div class="divTable">
                <div class="divTableBody">
                  <div class="divTableRow div-title">
                    <div class="divTableCell div-title" style="width: 25%">Voucher Code</div>
                    <div class="divTableCell div-title" style="width: 25%">Expiry Date</div>
                    <div class="divTableCell div-title" style="width: 20%">Max Users</div>
                    <div class="divTableCell div-title" style="width: 20%">Current Users</div>
                    <div class="divTableCell div-title" style="width: 10%">&nbsp;</div>
                  </div>
                </div>
              </div>
              <br>
              <div class="divTable">
                <div class="divTableBody">
                  <div *ngFor="let voucher of voucherRows; let i = index" class="divTableRow md-input">
                    <div class="divTableCell" style="width: 25%">
                      <input class="md-form-control text-center voucherCode"
                             onPaste="return false"
                             [disabled]="!voucher.new"
                             maxlength="10"
                             required
                             type="text"
                             [id]="'voucherCode_' + i "
                             style="width: 100%; display: inline;"
                             [(ngModel)]="voucher.code"
                             oninput="this.value = this.value.toUpperCase()"
                             [ngClass]="{'error': (submitted && this.domainReqErr && i == 0)}">
                    </div>
                    <div class="divTableCell" style="width: 25%">
                      <input
                        class="md-form-control text-center voucherExpiry"
                        name="expiryDate"
                        ngbDatepicker
                        [id]="'voucherExpiry_' + i "
                        (click)="td.toggle()"
                        (dateSelect)="onDateToSelection($event)"
                        #td="ngbDatepicker"
                        id="dateInputTo"
                        [(ngModel)]="voucher.expiry_date"
                        readonly
                      >
                    </div>
                    <div class="divTableCell" style="width: 20%">
                      <input class="md-form-control text-center voucherMaxUser"
                             onPaste="return false"
                             maxlength="6"
                             required
                             type="number"
                             [id]="'voucherMaxUser_' + i "
                             style="width: 100%; display: inline;"
                             min="1" max="999999"
                             [(ngModel)]="voucher.max_users"
                             (keypress)="onlyNumberKey($event)"
                             [ngClass]="{'error': (submitted && this.domainReqErr && i == 0)}">
                    </div>
                    <div class="divTableCell text-center" style="width: 20%">
                      {{ voucher.current_users }}
                    </div>
                    <div class="divTableCell text-center" style="width: 10%">
                        <i class="fa fa-trash pointer" (click)="deleteVoucherRow(i, voucher.code, voucher.new)"></i>
                        <span id="openDeleteConfirmModal" data-toggle="modal" data-target="#deleteVoucherModal"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="" style="margin:10px 0px 0px 0px;">
                <button type="button" class="badge module-button-white not-active mt-2" (click)="addVoucherRow()">+ Add Vouchers</button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary btn-modal-save" (click)="updateVouchers()">
              <img src="../../../../assets/images/loader.gif" *ngIf="loading">Save</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Update Voucher Modal -->

    <!-- Delete Voucher Modal -->
    <div class="modal fade" id="deleteVoucherModal" tabindex="-1" role="dialog" aria-labelledby="updateNameLabel" aria-hidden="true">
      <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content" style="border: 1px solid">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" >Delete Voucher Code</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-0">
            <p>Are you sure to delete this voucher code?</p>
            <p class="text-center mb-0"><strong>{{ deleteVoucherCode }}</strong></p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-modal-cancel" id="deleteVoucherCancel" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-danger" (click)="deleteVoucherRowConfirm()">
              <img src="../../../../assets/images/loader.gif" *ngIf="loading">Delete</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Total Users Modal -->
    <div class="modal fade" id="updateTotalUsersModal" tabindex="-1" role="dialog" aria-labelledby="updateTotalUsersLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="editOrganisationLabel">Update Company size</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
            <form [formGroup]="updateTotalUsersForm" (ngSubmit)="updateTotalUsers()">
            <div class="modal-body">
              <div class="md-input">
                <input class="md-form-control"
                      type="number"
                      required
                      formControlName="total_users"
                      value="{{total_users}}"
                      [ngClass]="{'error': (submitted && updateTotalUsersForm.invalid && ftotalusers.total_users.invalid) || (ftotalusers.total_users.dirty && ftotalusers.total_users.invalid)}">
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Company size</label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">Cancel</button>
              <button type="submit" class="btn btn-primary btn-modal-save">
                <img src="../../../../assets/images/loader.gif" *ngIf="loading">Save</button>
            </div>
            </form>
        </div>
      </div>
    </div>
    <!-- End Name Modal -->

  </div>
</div>
